import { useCallback } from 'react';

export const useCurrencyFormat = () => {
  const formatCurrency = useCallback((value) => {
    const number = parseFloat(value);
    if (isNaN(number)) {
      return 'Valor no válido';
    }
    return number.toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }, []);

  return formatCurrency;
};
